import React from "react";
import { MapPin, Phone, Clock, Mail } from "lucide-react";

export default function ContactInformation() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="space-y-8">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-3xl font-serif text-gray-800 mb-2">
            Contact Information
          </h1>
          <div className="w-24 h-1 bg-gray-200 mx-auto rounded-full"></div>
        </div>

        {/* Monastery Name and Address */}
        <div className="space-y-2">
          <h2 className="text-xl text-gray-800 font-medium">
            Thai Plum Village - Plum Village Thailand
          </h2>
          <div className="flex items-start space-x-2 text-gray-600">
            <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
            <div>
              <p>174,176 Moo 7</p>
              <p>Tambon Pongtalong,</p>
              <p>Pak Chong, NakornRatchasima, Thailand</p>
              <p>30450</p>
            </div>
          </div>
        </div>

        {/* Contact Hours */}
        <div className="space-y-2">
          <h2 className="text-xl text-gray-800 font-medium">
            Volunteer Contact Hours
          </h2>
          <div className="flex items-start space-x-2 text-gray-600">
            <Clock className="w-5 h-5 mt-1 flex-shrink-0" />
            <div>
              <p>10:00-12:00 & 14:00-17:00</p>
              <p>Tuesday to Saturday</p>
            </div>
          </div>
        </div>

        {/* Phone */}
        <div className="flex items-center space-x-2 text-gray-600">
          <Phone className="w-5 h-5 flex-shrink-0" />
          <a
            href="tel:+66963066865"
            className="hover:text-gray-800 transition-colors"
          >
            +66 96 306 6865
          </a>
        </div>

        {/* Email */}
        <div className="flex items-center space-x-2 text-gray-600">
          <Mail className="w-5 h-5 flex-shrink-0" />
          <a
            href="mailto:visitus@thaiplumvillage.org"
            className="hover:text-gray-800 transition-colors"
          >
            visitus@thaiplumvillage.org
          </a>
        </div>
      </div>
    </div>
  );
}
